import {  NgModule } from '@angular/core';
import { BemVindoRoutingModule } from './bem-vindo.routing.module';

import { 
  BemVindoComponent
} from './index.component';

@NgModule({
  imports: [BemVindoRoutingModule],
  declarations: [
  BemVindoComponent
  ]
})
export class BemVindoModule {}
